import { createSelector } from '@ngrx/store';

import { surveyFeature } from '../survey.feature';

const { selectManageSurvey } = surveyFeature;

export const selectSurvey = createSelector(
  selectManageSurvey,
  ({ survey }) => survey,
);

export const selectChildSurvey = createSelector(
  selectManageSurvey,
  ({ childSurvey }) => childSurvey,
);

export const selectChildSurveyLoading = createSelector(
  selectManageSurvey,
  ({ childSurveyLoading }) => childSurveyLoading,
);

export const selectChildSurveyError = createSelector(
  selectManageSurvey,
  ({ childSurveyError }) => childSurveyError,
);

export const selectManageSurveyLoading = createSelector(
  selectManageSurvey,
  ({ loading }) => loading,
);

export const selectManageSurveyError = createSelector(
  selectManageSurvey,
  ({ error }) => error,
);

export const selectQuotas = createSelector(
  selectManageSurvey,
  ({ quotas }) => quotas,
);

export const selectQuotaTotal = createSelector(
  selectManageSurvey,
  ({ quotaTotal }) => quotaTotal,
);

export const selectQuotaLoadedPage = createSelector(
  selectManageSurvey,
  ({ quotaLoadedPage }) => quotaLoadedPage,
);

export const selectQuotasLoadingMore = createSelector(
  selectManageSurvey,
  ({ quotasLoadingMore }) => quotasLoadingMore,
);

export const selectQuotaLockingIds = createSelector(
  selectManageSurvey,
  ({ quotaLockingIds }) => quotaLockingIds,
);

export const selectQuotaSavingIds = createSelector(
  selectManageSurvey,
  ({ quotaSavingIds }) => quotaSavingIds,
);

export const selectTrafficChannels = createSelector(
  selectManageSurvey,
  ({ trafficChannels }) => trafficChannels,
);

export const selectTrafficChannelsLoading = createSelector(
  selectManageSurvey,
  ({ trafficChannelsLoading }) => trafficChannelsLoading,
);

export const selectTrafficChannelsError = createSelector(
  selectManageSurvey,
  ({ trafficChannelsError }) => trafficChannelsError,
);

export const selectTcStatusChangingIds = createSelector(
  selectManageSurvey,
  ({ tcStatusChangingIds }) => tcStatusChangingIds,
);

export const selectCreatingTrafficChannel = createSelector(
  selectManageSurvey,
  ({ creatingTrafficChannel }) => creatingTrafficChannel,
);

export const selectTrafficChannelCreationError = createSelector(
  selectManageSurvey,
  ({ trafficChannelCreationError }) => trafficChannelCreationError,
);

export const selectPsidUploadLoading = createSelector(
  selectManageSurvey,
  ({ psidUploadLoading }) => psidUploadLoading,
);

export const selectPsidUploadError = createSelector(
  selectManageSurvey,
  ({ psidUploadError }) => psidUploadError,
);

export const selectPsidUploadFilePath = createSelector(
  selectManageSurvey,
  ({ psidUploadFilePath }) => psidUploadFilePath,
);

export const selectPsidUploadUniqCount = createSelector(
  selectManageSurvey,
  ({ psidUploadUniqCount }) => psidUploadUniqCount,
);

export const selectPsidUploadTotalCount = createSelector(
  selectManageSurvey,
  ({ psidUploadTotalCount }) => psidUploadTotalCount,
);
